import { Head } from "@inertiajs/react"
import { useTranslation } from "react-i18next"

import { CreatorLeaderboardView } from "@/components/creator-leaderboard/creator-leaderboard-view"
import AppLayout from "@/layouts/app-layout"
import type { CreatorLeaderboardProps } from "@/types/creator-leaderboard"

/**
 * OKS-519 — Creator/Leaderboard.tsx (`/leaderboard`), §13 redesign.
 *
 * Mobile-first creator surface inside `AppLayout` (creator shell + bottom-
 * tab nav). Weekly podium + ±2 around-you board — no period tabs (the
 * month/quarter/all surface stays on brand-admin `/crew/leaderboard`).
 *
 * # Brand isolation
 *
 * All props come from `CreatorLeaderboardController`, scoped to
 * `Current.brand` + `Current.membership`. No client-side query, no cross-
 * brand surface. A brand switch via `CrewSwitcher` is a full Inertia visit
 * → the page re-renders with the new brand's weekly board.
 */
export default function CreatorLeaderboard(props: CreatorLeaderboardProps) {
  const { t } = useTranslation()

  return (
    <AppLayout>
      <Head title={t("leaderboard.creator.heading")} />

      <main className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 py-6">
        <CreatorLeaderboardView {...props} />
      </main>
    </AppLayout>
  )
}
